import Swal from 'sweetalert2'
import { COLOR_APP } from '../constants'

export const successSwal = (item) => {
    Swal.fire({
        icon: 'success',
        title: item,
        showConfirmButton: false,
        timer: 1800
    })
}
export const successUpdateSwal = (item) => {
    Swal.fire({
        icon: 'success',
        title: item,
        showConfirmButton: false,
        timer: 1800
    })
}
export const successDeleteSwal = (item) => {
    Swal.fire({
        icon: 'success',
        title: item,
        showConfirmButton: false,
        timer: 1800
    })
}
export const errorSwal = (text, icon) => {
    Swal.fire({
        icon: icon ? icon : 'error',
        title: "ມີບາງຢ່າງຜິດພາດ",
        text: text ? text : "ຂໍ້ມູນລົ້ມແຫຼວ",
        showConfirmButton: false,
        timer: 7000
    })
}


export const errorTitleWithTextSwal = (title, text) => {
    Swal.fire({
        icon: 'error',
        title,
        text,
        showConfirmButton: false,
        timer: 5000
    })
}

export const errorPermissionTitleWithTextSwal = (title, text) => {
    Swal.fire({
        icon: 'error',
        title,
        text,
        showConfirmButton: false,
        focusDeny: false,
        focusCancel: false,
        returnFocus: false,
        showCloseButton: true
    })
}

export const wariningWithTextAndConfirmButton = (title, detail, onConfirm) => {
    Swal.fire({
        title: title,
        text: detail,
        icon: 'success',
        timer: 5000
    }).then(async () => {
        try {
            await onConfirm()
        } catch (error) {
            console.log("Error: ", error)
        }
    })
}

export const requestionFields = ({text}) => {
    Swal.fire({
        position: "top",
        icon: "error",
        title: text ?? "ກະລຸນາປ້ອນຂໍ້ມູນກ່ອນ",
        showConfirmButton: false,
        timer: 4000
      });
}
